import { all, fork } from 'redux-saga/effects';

import watchFindTextRequest from './findTextRequest';
import watchGetBrandsRequest from './getBrandsRequest';
import watchGetCategoriesRequest from './getCategoriesRequest';

function* siteMapSagas() {
  yield all([fork(watchGetCategoriesRequest), fork(watchGetBrandsRequest), fork(watchFindTextRequest)]);
}

export default siteMapSagas;
